import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let kejianrouter = new Router({
  mode: 'history',     // 使用HTML5 History Mode
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },

    // {
    // path: "/huanong",
    // name: "huanong",
    // component: () => import("./views/huanong.vue"),
    // },

    {
      path: "/business",
      name: "business",
      component: () => import("./views/huanong.vue"),
    },

    // {
    // path: "/business",
    // name: "business",
    // component: () => import("./views/Business.vue"),
    // },

    {
      path: "/service",
      name: "service",
      component: () => import("./views/Business.vue"),
      },

    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue"),
    },

    {
      path: "/ca",
      name: "ca",
      component: () => import("./views/Ca.vue"),
    },
  ],
});

export default kejianrouter;
